import React from "react";
import { Button} from "../ui/button";
import { Link } from "react-router-dom";
import { PopupWidget } from "react-calendly";

const CTA = () => {
  return (
    <section className="py-16">
      <div className="container px-4 md:px-6">
        <div className="bg-gradient-to-r bg-background/30 rounded-3xl overflow-hidden shadow-xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div className="p-8 md:p-12 lg:p-16">
              <h2 className="text-3xl md:text-4xl text-primary font-bold  mb-4">
                Ready to Grow Your Practice?
              </h2>
              <p className="text-lg  mb-8 max-w-md">
                Join our network of culturally competent therapists serving the BIPOC community.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a href="/therapists/sign_up">
                  <Button className="rounded-full px-8 py-6 h-auto text-lg">
                    Join Today
                  </Button>
                </a>
                <a href="https://calendly.com/safdarzeeshan/mindpulse-therapy" >
                  <Button variant="outline" className="border-primary/90 hover:bg-primary text-primary hover:text-white rounded-full px-8 py-6 h-auto text-lg">
                    Contact Us
                  </Button>
                </a>
              </div>
            </div>
            <div className="hidden md:block relative h-full min-h-[300px]">
              <img
                alt="Therapist"
                src="https://res.cloudinary.com/dm9jepekh/image/upload/v1745984117/pexels-olly-3769021_rci38s.jpg"
                className="absolute inset-0 h-full w-full object-cover opacity-80"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CTA;